import { Input, SegmentedControl, Select } from '@/shared/components';
import { I } from '@/shared/icons';
import type { ObjectSort, ObjectStatusFilter, ObjectView } from './objectOverview';

const STATUS_OPTIONS: ReadonlyArray<{ value: ObjectStatusFilter; label: string }> = [
  { value: 'all', label: 'Alle Objekte' },
  { value: 'review', label: 'Prüfung nötig' },
  { value: 'Active', label: 'Mit aktiven Apartments' },
  { value: 'Draft', label: 'Mit Entwürfen' },
  { value: 'Paused', label: 'Mit pausierten' },
  { value: 'Archived', label: 'Mit archivierten' },
];

const SORT_OPTIONS: ReadonlyArray<{ value: ObjectSort; label: string }> = [
  { value: 'name-asc', label: 'Name A–Z' },
  { value: 'name-desc', label: 'Name Z–A' },
  { value: 'apartments-desc', label: 'Meiste Apartments' },
  { value: 'review-first', label: 'Prüfung zuerst' },
];

const VIEW_OPTIONS: ReadonlyArray<{ value: ObjectView; label: string }> = [
  { value: 'list', label: 'Liste' },
  { value: 'cards', label: 'Karten' },
];

interface ObjectOverviewToolbarProps {
  search: string;
  onSearch: (value: string) => void;
  status: ObjectStatusFilter;
  onStatus: (value: ObjectStatusFilter) => void;
  sort: ObjectSort;
  onSort: (value: ObjectSort) => void;
  view: ObjectView;
  onView: (value: ObjectView) => void;
  showViewToggle: boolean;
}

export function ObjectOverviewToolbar({
  search,
  onSearch,
  status,
  onStatus,
  sort,
  onSort,
  view,
  onView,
  showViewToggle,
}: ObjectOverviewToolbarProps) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-3">
      <Input
        leftIcon={<I name="Search" size={16} />}
        placeholder="Nach Objekt oder Adresse suchen…"
        aria-label="Objekte durchsuchen"
        value={search}
        onChange={(event) => onSearch(event.target.value)}
        className="min-w-56 max-w-md flex-1"
      />
      <Select
        aria-label="Nach Status filtern"
        value={status}
        onChange={(event) => onStatus(event.target.value as ObjectStatusFilter)}
        className="w-auto"
      >
        {STATUS_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      <Select
        aria-label="Sortierung"
        value={sort}
        onChange={(event) => onSort(event.target.value as ObjectSort)}
        className="w-auto"
      >
        {SORT_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      {showViewToggle && (
        <SegmentedControl
          value={view}
          onChange={onView}
          options={VIEW_OPTIONS}
          className="ml-auto"
        />
      )}
    </div>
  );
}
